module.exports = __webpack_public_path__ + "img/icon_tm.7817f787.png";